import React from 'react';

import {
  IonCard,
  IonCardContent,
  IonCardTitle,
  IonSkeletonText,
} from '@ionic/react';

import './index.css';

const SummaryCardSkeleton = () => {
  return (
    <IonCard className={'border radius'}>
      <IonCardContent>
        <span>
          <IonSkeletonText animated className={'widgets-skeleton-header'} />
        </span>
        <IonCardTitle>
          <IonSkeletonText animated className={'widgets-skeleton-value'} />
        </IonCardTitle>
      </IonCardContent>
    </IonCard>
  );
};
export default SummaryCardSkeleton;
